import React, { lazy } from "react";

const LazyTaskInformation = lazy(() => import("./TaskInformation"));

const TaskInformation = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyTaskInformation taskId={""} {...props} />;

export default TaskInformation;
